@for (item of items; track $index) {
  <myre-item
    [item]="item"
    [isClickable]="canToggleDataVisibility"
    (mouseenter)="_displayHoverStateInGraph(item.index, true)"
    (mouseleave)="_displayHoverStateInGraph(item.index, false)"
    (onClick)="_toggleDataVisibility(item.index)"
  />
}
